import { useEffect, useState } from "react";

// The answer is generated in the background and can legitimately take a couple
// of minutes when files are involved, so say so rather than spinning silently.
const SLOW_AFTER_MS = 15000;

export default function ChatbotTypingIndicator({ surface, latestRef = null }) {
  const prefix = surface === "widget" ? "chatbot-widget" : "chatbot-fullscreen";
  const [slow, setSlow] = useState(false);

  useEffect(() => {
    const timer = window.setTimeout(() => setSlow(true), SLOW_AFTER_MS);

    return () => window.clearTimeout(timer);
  }, []);

  return (
    <article ref={latestRef} className={`${prefix}__message ${prefix}__message--assistant`}>
      <div className={`${prefix}__message-label`}>Obsero AI</div>
      <div className={`${prefix}__message-body d-flex align-items-center gap-2`}>
        <div className="spinner-border spinner-border-sm text-secondary" role="status" aria-label="Arbejder" />
        {slow ? (
          <span className="text-secondary small">Arbejder på svaret. Det kan tage et par minutter.</span>
        ) : null}
      </div>
    </article>
  );
}
